var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryFoodie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/choose category Copy 3@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-662.000000, -730.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.000000, 47.000000)",
    id: "pepper"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.727273, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20436364,3.608 L7.13636364,3.608 C7.07418182,2.02618182 7.22436364,0.945818182 8.22727273,0.241818182 C8.43924975,0.0977677069 8.71207593,0.0780720696 8.94254545,0.190181818 L9.73090909,0.563272727 C9.7906338,0.59138103 9.83043313,0.649650758 9.83488911,0.71550865 C9.83934509,0.781366541 9.80775769,0.844466335 9.75236364,0.880363636 C8.87527273,1.43090909 8.37563636,2.20909091 8.20436364,3.608 Z",
    id: "Path",
    fill: "#72C472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39636364,16 C2.84284623,15.9958767 1.52158312,14.8657416 1.27672727,13.3316364 L0.0527272727,6.95272727 C-0.180356356,5.50357243 0.37548166,4.03989436 1.51173428,3.11075083 C2.64798691,2.1816073 4.19288717,1.92745665 5.56690909,2.44363636 L7.63636364,3.21963636 L9.70581818,2.44436364 C11.3741238,1.81544462 13.2576582,2.33339455 14.3698182,3.72690909 L14.3698182,3.72690909 C15.0923069,4.63125727 15.401477,5.79760578 15.2218182,6.94109091 L13.9941818,13.3454545 C13.8371261,14.312936 13.2401159,15.1528124 12.3779955,15.6191121 C11.5158752,16.0854117 10.4862066,16.1253656 9.59054545,15.7272727 L7.63636364,14.8578182 L5.68218182,15.7258182 C5.27750474,15.9062452 4.83944074,15.9996559 4.39636364,16 Z",
    id: "Path",
    fill: "#E86C60"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryFoodie);
export default __webpack_public_path__ + "static/media/category_foodie.fd9694c5e6f9739c19075eddcf6f1e53.svg";
export { ForwardRef as ReactComponent };